const FormStep = (props) => {
  return (
  <div className="form-steps" id="estimate-aid-box">
    <form>
      { props.children }
    </form>
  </div>
  );
};

export default FormStep;
export {ERROR_LIST} from "./bi/constants/ERROR_LIST";
export {RADIO_ERROR_ID} from "./bi/constants/RADIO_ERROR_ID";